import React from 'react';
import Loadable from 'react-loadable';
import { Provider } from 'react-redux';
import { hot } from 'react-hot-loader';
import { CookiesProvider } from 'react-cookie';
import { createBrowserHistory } from 'history';
import { ConnectedRouter } from 'connected-react-router';
import { hydrate, unmountComponentAtNode } from 'react-dom';
import { setupFeatureFramework, identitySelector } from '@surfline/web-common';

import MeteringContainer from '../containers/MeteringContainer';
import createStore from '../stores';
import config from '../config';

import '@surfline/quiver-themes/stylesheets/normalize.css';
import '../styles/base.scss';

const root = document.querySelector('#root');

const preloadedState = window.__DATA__; // eslint-disable-line no-underscore-dangle

const history = createBrowserHistory();

// Create a history of your choosing (we're using a browser history in this case)
const store = createStore(preloadedState, history);

window.wavetrakStore = store;

const mount = () => {
  // eslint-disable-next-line global-require,import/newline-after-import
  const Routes = hot(module)(require('../components/Routes').default);

  Loadable.preloadReady().then(() => {
    hydrate(
      <CookiesProvider>
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <Routes />
            <MeteringContainer />
          </ConnectedRouter>
        </Provider>
      </CookiesProvider>,
      root,
    );
  });
};

setupFeatureFramework(config.appKeys.splitio, identitySelector(store.getState()))
  .then(mount)
  .catch(mount);

if (module.hot) {
  module.hot.accept('../components/Routes', () => {
    unmountComponentAtNode(root);
    mount();
  });
}
